import React from 'react';
import Text, { H3 } from '@dbk/ui-text';
import PropTypes from 'prop-types';
import uiJson from '../../../../@extension/CH/src/data/ui.json';
import config from '../../../data/settings.json';
import envConfig from '../../../../db-env-build';
import { InstatntMessenger, PDF, CallBackRequest } from '@dbk/ui-icons';
import { PALETTE,INVESTMENT_CONSTANTS,INVESTMENT_API_CODES, EBANKINGWEBLUX, KEY_CODE } from '../../../constants';
import { downloadPdf } from '../../../muster/utils/downloader';
import ui from '../../../../@extension/CH/src/data/ui.json';
// import Button from '../../../components/common/button-view';
import Button from '@dbk/ui-buttons';
import isEnterorSpaceKeyPressed from '../../../utils/isEnterorSpaceKeyPressed';

const RegisterNewDevice = (props) => {

    const remoteUrl = window.location.origin + config.environments.relative.remoteUrl;

    let path;
    let fileName="";
    if (props.destLanguageCode === 'de-CH') {
        path = ui.pdf.registerNewDeviceGerman;
        fileName = "DWO_Register_New_Device_GER.pdf"
    } else {
        path = ui.pdf.registerNewDevice;
        fileName = "DWO_Register_New_Device_ENG.pdf"
    }

    const downloadLink = remoteUrl + path;
    // const downloadLink =  "https://int7.mywealthasia.intranet.db.com/ebanking"  + path;  // for local testing
    const onDownload = (e) => { 
      if(isEnterorSpaceKeyPressed(e)){
        downloadPdf(downloadLink, fileName);
      }
    }

    return (
      <div className="register-new-device">
        <div className="margin-10">
          <Text size="large" className="registerDeviceFocus" tabIndex={0} aria-label={props.messages['app.login.new.mobile.phone.desc']}>{props.messages['app.login.new.mobile.phone.desc']}</Text>
          <span id='registerNewDeviceLink'>
          <div aria-labelledby='registerNewDeviceLink' role="link" tabIndex={0} className="login-body-footer margin-top-20 margin-bottom-20 cursor-pointer" aria-label={props.messages['app.accessibility.login.registerNewDeviceInstruction']} onKeyDown={(e) => onDownload(e) } onClick={() => onDownload()}>
             <PDF width={48} height={48} color={PALETTE.touchableOpacityEnable}/>
             <a className='margin-right-40 margin-left-10 link-large'>{props.messages['app.login.new.mobile.phone']}</a>
          </div>
          </span>

          <Text size="large" tabIndex={0} aria-label={props.messages['app.login.new.mobile.phone.contact.rm']}>{props.messages['app.login.new.mobile.phone.contact.rm']}</Text>
        </div>
        <div className="logout-confirm-btns margin-top-20">
          <div className="center small-2">
            <Button testID="logout_popup_no_button" id="logout_popup_no_button" size="large"
              onClick={props.closeModal}
            > {props.messages['app.forgotPassword.button.ok']}</Button>
          </div>
        </div>
      </div>
    );

};

RegisterNewDevice.propTypes = {
  messages: PropTypes.object,
};

RegisterNewDevice.defaultProps = {

};

export default RegisterNewDevice;